import { createSelector } from 'reselect'

export const getRemoteOrderTotal = (state) => {
  return state?.orderTotalRemote
}

export const makeGetRemoteOrderTotal = () => createSelector(
  [getRemoteOrderTotal],
  (total) => total
)
